module.exports = __webpack_public_path__ + "0900c6d95eba9b003351a80c37e8ab16.MP3";